import { formatDate, fullName, parseIsoDate } from "core"
import { useContext } from "react"
import { useTranslation } from "react-i18next"
import { AccountContext } from "../../context/AccountContext"
import { AccountCard, CardError, Field } from "./AccountCard"

export const PersonalInformation = () => {
  const { t, i18n } = useTranslation()
  const { profile, loading, errors } = useContext(AccountContext)

  const dateOfBirth = profile?.dateOfBirth
    ? parseIsoDate(profile.dateOfBirth)
    : null

  const notAdded = t("loginSecurity.notAdded")

  return (
    <AccountCard title={t("loginSecurity.personalInformation")}>
      {errors.profile ? (
        <CardError />
      ) : (
        <>
          <Field
            label={t("loginSecurity.name")}
            value={profile ? fullName(profile) : ""}
            placeholder={notAdded}
            isLoading={loading}
          />
          <Field
            label={t("loginSecurity.preferredName")}
            value={profile?.preferredName}
            placeholder={notAdded}
            isLoading={loading}
          />
          <Field
            label={t("loginSecurity.dateOfBirth")}
            value={dateOfBirth ? formatDate(dateOfBirth, i18n.language) : ""}
            placeholder={notAdded}
            isLoading={loading}
          />
        </>
      )}
    </AccountCard>
  )
}
